import {Injectable, Injector} from "@angular/core";
import {CrudService} from "@mango/core";
import {HttpClient} from "@angular/common/http";
import {Company} from "./company";

@Injectable()
export class CompanyService extends CrudService<Company> {

  constructor(injector: Injector, protected http: HttpClient) {
    super(Company, injector);
  }
}
